<template>
    <div class="uniform-uploader">
        <AppFile ref="fileInput" :accept="['.pdf']" :multiple="false" @fileIsSelected="onFileSelected" />
        <span class="filename" style="user-select: none;" :title="fileName">{{ fileName }}</span>
        <button type="button" class="btn btn-light btn-icon legitRipple ml-2" :disabled="uploading || disabled" :title="$t('buttons.upload')" @click="$refs.fileInput.showFile()">
            <i class="icon-plus3"></i>
        </button>
        <button type="button" :disabled="!hasFile" class="btn btn-light btn-icon legitRipple ml-2" @click="viewFile">
            <i class="icon-file-pdf"></i>
        </button>
    </div>
</template>
<script>
import AppFile from "./AppFile.vue";
import { httpClient } from "../../../services/HttpClient";
import MessageNotificator from "../../../services/MessageNotificator";

export default {
    name: 'UniformFileUpload',
    components: { AppFile },
    props: {
        type: {
            type: String,
            required: true
        },
        disabled: {
            type: Boolean,
            default: false
        },
        existingFile: {
            type: Object,
            default: null
        }
    },
    emits: ['update:modelValue'],
    data() {
        return {
            localFile: null,
            uploading: false
        }
    },
    computed: {
        hasFile() {
            return !!this.localFile || !!this.existingFile;
        },
        fileName() {
            if (this.localFile) return this.localFile.name;
            if (this.existingFile) return this.existingFile.url.split('/').pop();
            return this.$t('labels.file_not_selected');
        }
    },
    methods: {
        async onFileSelected(files) {
            const file = files[0];
            if (!file) return;

            if (file.type !== 'application/pdf') {
                new MessageNotificator().error(this.$t('alerts.only_pdf_allowed'));
                return;
            }

            this.uploading = true;

            const formData = new FormData();
            formData.append('file', file);
            formData.append('type', this.type);

            try {
                const response = await httpClient.post('/file/files', formData);
                this.localFile = file;
                this.$emit('update:modelValue', response.data.data);
            } finally {
                this.uploading = false;
            }
        },
        viewFile() {
            if (this.localFile) {
                const url = URL.createObjectURL(this.localFile);
                window.open(url, '_blank');
            } else if (this.existingFile) {
                window.open(this.existingFile.url, '_blank');
            }
        }
    }
}
</script>
<style scoped>
/* the theme lets the name wrap onto a second line — keep it on one and cut it off instead */
.uniform-uploader .filename {
    word-break: normal;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    min-width: 0;
}

.uniform-uploader .btn {
    flex-shrink: 0;
}
</style>
